// 系统设置接口
import http from '../utils/request'

export default {
  // 获取个人信息
  userInfo() {
    return http.get('/pc/clientApi/account/userInfo')
  },
  // 修改个人信息
  updateUserInfo(data) {
    return http.post('/pc/clientApi/account/updateUserInfo', data)
  },
  // 获取logo
  logoInfo() {
    return http.get('/pc/clientApi/account/logoInfo')
  }
}
